// Function to replace placeholders with images
function replacePlaceholders() {
  const consUrl = 'https://cdn.shopify.com/s/files/1/0852/7858/9259/files/con-icon.svg?v=1731500776'; 
  const prosUrl = 'https://cdn.shopify.com/s/files/1/0852/7858/9259/files/pro-icon.svg?v=1731500776'; 
  // Select the element containing the text
  const container = document.querySelector('.product-info__block-group.accordion-group'); 

  if (container) {
    container.innerHTML = container.innerHTML
    .replace(/%@/g, `<img src="${prosUrl}" class="pros-cons" alt="Pro">`)
    .replace(/%X/g, `<img src="${consUrl}" class="pros-cons" alt="Con">`);
  }
}

// Run the replacement function when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', replacePlaceholders);
